import {
  Alignment,
  Button,
  Classes,
  Dialog,
  HTMLSelect,
  InputGroup,
  Switch,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalc, IContestacao, IEmpresa, IResultadoItem } from "../../model";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import CurrencyInput from "../utils/CurrencyInput";
import MomentLocaleUtils from "react-day-picker/moment";
import { FormGroup } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import { CalcRSStore } from "../../stores/calculo-rs/CalcRSStore";
import { AppStore } from "../../stores/AppStore";
import { GenerateCalcOptions } from "./calcs_options";
import { CalcSelect } from "../calculos/CalcSelect";
import { filterCalcs, renderCalcs } from "../utils/CalcSelect";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";
const numeral = require("numeral");

interface ContestarDialogProps {
  item: IResultadoItem;
  tipo: string;
  modelo: string;
  onClose: () => void;
  onCancel: () => void;
  empresaSelecionada: IEmpresa;
}

interface ContestarDialogState {
}

@observer
export class ContestarDialog
  extends React.Component<ContestarDialogProps, ContestarDialogState> {
  obs = observable({
    contestacao: {} as IContestacao,
    empresa_selecionada: {} as IEmpresa,
    memoria_salvar: false as boolean,
    retroativas: true as boolean,
    aplicar_retencao: false as boolean,
    alterar_data: false as boolean,
    isDevolucao: false,
    calc_selecionado: null,
    calc_devolucao_selecionado: null,
    cnpj_memoria: true as boolean,
    open_ajuda: false as boolean

  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount(): Promise<void> {

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      await CalcRSStore.load();

      this.obs.calc_selecionado = CalcRSStore.obs.calcs.find(x => x._id == this.props.item.calc_id)

    } else {

      await CalcStore.load();

      this.obs.calc_selecionado = CalcStore.obs.calcs.find(x => x._id == this.props.item.calc_id)

    }

    this.obs.contestacao = observable({
      nota_item_ids: [this.props.item.id],
      valor_contestado: parseFloat(this.props.item.valor_contestacao_icms) || 0,
      contestacao_data: null,
      motivo: this.props.item.motivo_contestacao_icms || "",
      contestacao_calc_id: null,
      mva: this.props.item.mva_usuario || 0,
      entrada_saida: this.props.tipo.toLocaleLowerCase().replace("í", "i"),
      modelo: this.props.modelo.toLowerCase(),
    });

  }

  handleConfirm = async () => {

    let devolucao = false

    if (this.obs.alterar_data) {

      if (!this.obs.contestacao.contestacao_data) {
        toast.warning('Por favor, selecione uma data.', {});
        return;
      }

      if (this.obs.contestacao.motivo == "") {
        toast.error('Por favor, preencha o motivo da contestação!', {});
        return
      }

      delete this.obs.contestacao.contestacao_calc_id_devolucao

      devolucao = false

    } else {

      if (!this.obs.calc_selecionado._id) {
        toast.warning('Por favor, selecione um cálculo.', {});
        return;
      }

      if (this.obs.contestacao.mva == null) {
        toast.error('Por favor, preencha o MVA do produto ou Mude para Contestar Selecionados!', {});
        return
      }

      if (this.obs.contestacao.motivo == "") {
        toast.error('Por favor, preencha o motivo da contestação!', {});
        return
      }

      if (this.obs.aplicar_retencao) {

        if (!this.obs.calc_devolucao_selecionado._id) {
          toast.warning('Por favor, selecione um cálculo para a retenção.', {});
          return;
        }

        this.obs.contestacao.contestacao_calc_id_devolucao = this.obs.calc_devolucao_selecionado._id
        this.obs.contestacao.contestacao_calc_id = this.obs.alterar_data ? null : this.obs.calc_selecionado._id

        devolucao = true

      } else {

        delete this.obs.contestacao.contestacao_calc_id_devolucao
        this.obs.contestacao.contestacao_calc_id = this.obs.alterar_data ? null : this.obs.calc_selecionado._id

        devolucao = false

      }

    }

    await ResultadoStore.create_contestacao_task(this.obs.contestacao, this.obs.memoria_salvar, ResultadoStore.obs.empresaContestar.uf, devolucao, ResultadoStore.obs.empresaContestar.cnpj, ResultadoStore.obs.date_start, ResultadoStore.obs.date_end, this.obs.cnpj_memoria)

    ResultadoStore.consulta_resultados_calculo()

    this.props.onClose();

  };

  handleContestarData(e) {
    this.obs.alterar_data = e

    this.obs.contestacao.contestacao_calc_id = null
    this.obs.contestacao.contestacao_calc_id_devolucao = null

    this.obs.calc_devolucao_selecionado = null
    this.obs.calc_selecionado = null

    this.obs.memoria_salvar = false
    this.obs.aplicar_retencao = false
  }

  handleValidDevolucao() {

    let calcOptions: any = []

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      calcOptions = CalcRSStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    } else {

      calcOptions = CalcStore.validForDate()?.find(obj => obj._id == this.obs.calc_selecionado._id)

      this.obs.isDevolucao = calcOptions?.devolucao ? calcOptions.devolucao : false

    }

  }

  render() {
    let tmp_tipo = this.props.tipo.toLowerCase().replace("í", "i");
    let tmp_modelo = this.props.modelo.toLowerCase().replace("-", "");

    let calcOptions: any = []
    let calcOptionsRetro: any = []
    let calcOptionsRetencao: any = []

    if (ResultadoStore.obs.empresaContestar.uf == "RS") {

      calcOptions = GenerateCalcOptions(CalcRSStore.validForDate(), tmp_tipo, tmp_modelo)
      calcOptionsRetro = GenerateCalcOptions(CalcRSStore.validForDateRetro(), tmp_tipo, tmp_modelo)

    } else {

      calcOptions = GenerateCalcOptions(CalcStore.validForDate(), tmp_tipo, tmp_modelo)
      calcOptionsRetro = GenerateCalcOptions(CalcStore.validForDateRetro(), tmp_tipo, tmp_modelo)

    }

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    calcOptionsRetencao = CalcStore.validForDate()?.map((calc: ICalc) => {

      if (calc["saida"] == true && calc[tmp_modelo] == true) {

        return calc

      }

      return null

    }).filter(option => option !== null);

    let calcText = !this.obs.calc_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_selecionado.nome.length >= 100 ? this.obs.calc_selecionado.nome.substring(0, 100) + "..." : this.obs.calc_selecionado.nome}`
    let devolucaoText = !this.obs.calc_devolucao_selecionado?.nome ? "Selecione o Cálculo" : `${this.obs.calc_devolucao_selecionado.nome.length >= 120 ? this.obs.calc_devolucao_selecionado.nome.substring(0, 120) + "..." : this.obs.calc_devolucao_selecionado.nome}`

    return (<>
      <Dialog
        isOpen={true}
        onClose={this.props.onClose}
        className="modal-contestacao"
      >
        <div className={Classes.DIALOG_HEADER}>
          <div style={{ display: "flex", width: "100%" }}>
            <h2 className="title-no-bottom">Contestar Cálculo</h2>
            {this.obs.isDevolucao && tmp_tipo == "entrada" && AppStore.obs1.selectedEmpresa.simples_nacional && (tmp_modelo.toLowerCase() == "nfe" || tmp_modelo.toLowerCase() == "nfce") &&
              <Switch
                label={"Aplicar retenção na saída?"}
                checked={this.obs.aplicar_retencao}
                onChange={(e: any) => this.obs.aplicar_retencao = e.target.checked}
                style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
              />
            }
          </div>
        </div>

        <div className={Classes.DIALOG_BODY}>

          <div className="item-dialog-grid" style={{ gridTemplateColumns: !this.obs.alterar_data ? "1fr 1fr 1fr" : "1fr 1fr", marginBottom: 24 }}>
            <div className="detalhamento-field">
              <span className="detalhamento-field-label">Valor Produto</span>
              <span className="detalhamento-field-value" style={{ fontSize: 15, fontWeight: 700 }}>
                {numeral(parseFloat(this.props.item.valor_produto) || 0).format("$ 0,0.00")}
              </span>
            </div>
            <div className="detalhamento-field">
              <span className="detalhamento-field-label">ICMS Calculado</span>
              <span className="detalhamento-field-value" style={{ fontSize: 15, fontWeight: 700 }}>
                {numeral(parseFloat(this.props.item.valor_icms_ant) || 0).format("$ 0,0.00")}
              </span>
            </div>
            {!this.obs.alterar_data && (
              <div className="detalhamento-field">
                <span className="detalhamento-field-label">Valor a Pagar</span>
                <span className="detalhamento-field-value valor-pagar" style={{ fontSize: 15 }}>
                  {numeral(parseFloat(this.props.item.valor_icms_ant) - this.obs.contestacao.valor_contestado).format("$ 0,0.00")}
                </span>
              </div>
            )}
          </div>

          {!this.obs.alterar_data ? (
            <div className="contestar-form">
              <div className="contestar-row">
                <FormGroup
                  label={<>Utilizar cálculo <span className="contestar-required">*</span></>}
                  className="empresaSelect calcSelect contestar-field-grow"
                >
                  <CalcSelect
                    items={this.obs.retroativas ? calcOptions : calcOptionsRetro}
                    itemRenderer={renderCalcs}
                    itemPredicate={filterCalcs}
                    onItemSelect={(e: ICalc) => {
                      this.obs.calc_selecionado = e
                      this.handleValidDevolucao()
                    }}
                    inputProps={{ placeholder: "Filtrar um Cálculo" }}
                    matchTargetWidth
                  >
                    <Button text={calcText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
                  </CalcSelect>
                </FormGroup>
                <FormGroup label={"\u200B"}>
                  <Switch
                    label={this.obs.retroativas ? "Cálculo Vigentes" : "Cálculos Retroativos"}
                    checked={this.obs.retroativas}
                    onChange={(e: any) => this.obs.retroativas = e.target.checked}
                    style={{ marginBottom: 0, marginTop: 12, flexShrink: 0 }}
                  />
                </FormGroup>
              </div>

              {this.obs.aplicar_retencao && (
                <div className="contestar-row">
                  <FormGroup label="Cálculo da retenção" className="empresaSelect calcSelect contestar-field-grow">
                    <CalcSelect
                      items={calcOptionsRetencao}
                      itemRenderer={renderCalcs}
                      itemPredicate={filterCalcs}
                      onItemSelect={(e: ICalc) => this.obs.calc_devolucao_selecionado = e}
                      inputProps={{ placeholder: "Filtrar um Cálculo" }}
                      matchTargetWidth
                    >
                      <Button text={devolucaoText} rightIcon="double-caret-vertical" alignText={Alignment.LEFT} />
                    </CalcSelect>
                  </FormGroup>
                </div>
              )}

              <div className="contestar-row">
                <FormGroup label="Valor Contestado" className="contestar-field-grow">
                  <CurrencyInput
                    allowNegative
                    value={this.obs.contestacao.valor_contestado}
                    showIcon={false}
                    onChange={val => this.obs.contestacao.valor_contestado = val}
                  />
                </FormGroup>
                <FormGroup label={<>Trocar MVA (%) <span className="contestar-required">*</span></>} className="contestar-field-grow">
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <CurrencyInput
                      value={this.obs.contestacao.mva}
                      precision={3}
                      showIcon={false}
                      onChange={val => this.obs.contestacao.mva = val}
                    />
                    <AppIcon name="clear" onClick={() => this.obs.contestacao.mva = 0} color="#d95050" style={{ cursor: "pointer" }} />
                    {/* <Button onClick={() => this.obs.contestacao.mva = 0} className="btnLimpar" style={{width: 100}}>Limpar</Button> */}
                  </div>
                </FormGroup>
              </div>

              <div className="contestar-row">
                <FormGroup label="Alterar data" style={{ flex: "0 0 180px" }}>
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.contestacao.contestacao_data ? new Date(this.obs.contestacao.contestacao_data) : null}
                    onChange={val => this.obs.contestacao.contestacao_data = val}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>
                <FormGroup label={<>Motivo <span className="contestar-required">*</span></>} className="contestar-field-grow">
                  <InputGroup
                    value={this.obs.contestacao.motivo}
                    onChange={(e: any) => this.obs.contestacao.motivo = e.target.value}
                  />
                </FormGroup>
              </div>
            </div>
          ) : (
            <div className="contestar-form">
              <div className="contestar-row">
                <FormGroup label={<>Alterar data <span className="contestar-required">*</span></>} style={{ flex: "0 0 180px" }}>
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.contestacao.contestacao_data ? new Date(this.obs.contestacao.contestacao_data) : null}
                    onChange={val => this.obs.contestacao.contestacao_data = val}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>
                <FormGroup label={<>Motivo <span className="contestar-required">*</span></>} className="contestar-field-grow">
                  <InputGroup
                    value={this.obs.contestacao.motivo}
                    onChange={(e: any) => this.obs.contestacao.motivo = e.target.value}
                  />
                </FormGroup>
              </div>
            </div>
          )}

          <div className="contestar-footer">
            <div className="contestar-switches">
              <div style={{ display: "flex", alignItems: "center" }}>
                <label style={{ width: 140, marginBottom: 0 }}>
                  Salvar contestação
                  {this.obs.memoria_salvar  && <AppIcon
                    name="help"
                    className="pulse-notification-pgdas"
                    color="blue"
                    style={{ cursor: "pointer", marginLeft: 5 }}
                    onClick={(e) => ResultadoStore.obs.open_ajuda_salvar = true}
                  />}
                </label>
                <Switch
                  alignIndicator={Alignment.RIGHT}
                  innerLabelChecked="Sim"
                  innerLabel="Não"
                  disabled={this.obs.alterar_data}
                  checked={this.obs.memoria_salvar}
                  onChange={(e: any) => this.obs.memoria_salvar = e.target.checked}
                />
              </div>
              <Switch
                label="Apenas data"
                alignIndicator={Alignment.RIGHT}
                innerLabelChecked="Sim"
                innerLabel="Não"
                onChange={(e: any) => this.handleContestarData(e.target.checked)}
                style={{ paddingTop: 10 }}
              />
              {this.obs.memoria_salvar && (
                <div style={{ display: "flex", alignItems: "center", paddingTop: 10 }} >
                  <label style={{ width: 140, marginBottom: 0 }}>
                    Memória CNPJ
                    <AppIcon
                      name="help"
                      className="pulse-notification-pgdas"
                      color="blue"
                      style={{ cursor: "pointer", marginLeft: 5 }}
                      onClick={() => this.obs.open_ajuda = true}
                    />
                  </label>
                  <Switch
                    alignIndicator={Alignment.RIGHT}
                    innerLabelChecked="Sim"
                    innerLabel="Não"
                    disabled={this.obs.alterar_data}
                    checked={this.obs.cnpj_memoria}
                    onChange={(e: any) => this.obs.cnpj_memoria = e.target.checked}
                  />
                </div>
              )}
            </div>

            <div className="contestar-actions">
              <Button text="Cancelar" onClick={() => this.props.onClose()} />
              <Button text="Contestar" intent="primary" onClick={this.handleConfirm} />
            </div>
          </div>
        </div>
      </Dialog>

      <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`

        <b>Memória CNPJ:</b><br /><br />

        <b>Ativada</b> – O sistema valida o CNPJ de origem nas entradas e o CNPJ de destino nas saídas para salvar a Memória de Cálculo.<br /><br />

        <b>Desativada</b> – O sistema não realiza a validação de CNPJ, permitindo salvar a Memória de Cálculo sem informações de CNPJ.<br /><br />

      `} />

    </>);
  }
}
